/** F606 Trainers page — bridge-backed listing of certified trainers. */
import { Trophy } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606TrainersPage() {
  return (
    <F606DataPage
      entity="trainers"
      titleAr="المدربون"
      titleEn="Trainers"
      icon={Trophy}
      emptyIcon={Trophy}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'name',
          ar: 'المدرّب', en: 'Trainer',
          render: (r) => {
            const p = r.trainer_profile || {};
            return (
              <div>
                <div className="font-bold text-white">
                  {p.display_name || r.full_name || r.name || '—'}
                </div>
                {(p.specialty || p.specialization || r.specialization) && (
                  <div className="text-[10px] text-white/40">
                    {p.specialty || p.specialization || r.specialization}
                  </div>
                )}
              </div>
            );
          },
        },
        { key: 'email', ar: 'الإيميل', en: 'Email', render: (r) => <span className="font-mono text-[11px]" dir="ltr">{r.email || '—'}</span> },
        {
          key: 'rating',
          ar: 'التقييم', en: 'Rating',
          render: (r) => {
            const rating = r.trainer_profile?.rating ?? r.rating;
            return rating != null
              ? <span className="font-mono text-amber-300">{Number(rating).toFixed(1)} ★</span>
              : '—';
          },
          className: 'w-20',
        },
        {
          key: 'clients',
          ar: 'العملاء', en: 'Clients',
          render: (r) => (
            r.trainer_profile?.students_count
            ?? r.students_count
            ?? r.clients_count
            ?? r.trainee_count
            ?? '—'
          ),
          className: 'w-20 text-center',
        },
        {
          key: 'is_verified',
          ar: 'موثّق', en: 'Verified',
          render: (r) => {
            // Consider a trainer "verified" if they have a trainer_code
            // assigned or an explicit is_verified flag.
            const verified = r.is_verified ?? Boolean(r.trainer_profile?.trainer_code);
            return (
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold border ${
                verified ? 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300' : 'bg-white/5 border-white/10 text-white/50'
              }`}>
                {verified ? '✓' : '—'}
              </span>
            );
          },
          className: 'w-24',
        },
      ]}
    />
  );
}
